import {useState, useEffect} from 'react';
import {getDocs, onSnapshot, doc, collection} from "firebase/firestore";
import { db } from '../firebase';
import {Link, useHistory} from "react-router-dom";
import pic from "../img/wishlist.png";
export default function Wishlist({user}) {

    const [wish, setWish] = useState();
    const [empty, setEmpty] = useState(false);
    useEffect(() => {
        if(user){
            let wishData = [];
            onSnapshot(collection(db, `users/${user.uid}/wishlist`), snap => {
                if(snap.empty){
                    setEmpty(true);
                }
                else{
                    snap.forEach((item) => {
                        wishData.push(item.data())
                    })
                    setWish(wishData);
                }
            })
            
        }
    }, [user])
  return (
    <div className='wishlist-page'>
        <h2 className='heading'>Your Wishlist</h2>

        <div className='wish-list'>
            <h3>Wishlist Items</h3>
            {wish && <div className='wish-listing'>
                {wish.map((item) => {
                    return <Link to = {`/category/${item.category}/${item.docName}`}><div className='wish-item'>
                        <img src = {item.itemImg}/>
                        <p>{item.itemName}</p>
                        <p>₦{item.itemPrice}</p>
                    </div></Link>
                })}
            </div>}

            {empty && <div className='wish-empty'>
                <img src = {pic}/>
                <p>Your Wishlist is Empty. <Link to = '/shop'>Start Shopping Now</Link></p>    
            </div>}
        </div>
    </div>
  )
}
